import React from 'react'
import { Helmet } from 'react-helmet'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { selectAppName } from 'root-redux/selects/common'

import { getPageIdFromPathname } from 'helpers/getPageIdFormPathname'

import { INDEXABLE_PAGES, META_INFO } from './constants'

export const MetaInfo: React.FC = () => {
  const appName = useSelector(selectAppName)
  const { pathname } = useLocation()

  if (!appName) return null

  const pageId = getPageIdFromPathname(pathname)
  const indexablePage = INDEXABLE_PAGES.find(
    (page) => page.appName === appName && page.pageId === pageId,
  )

  return (
    <Helmet>
      <title>{indexablePage?.title ?? META_INFO[appName].title}</title>
      <link rel="icon" href={META_INFO[appName].favicon} />
      {META_INFO[appName].fontsLink && (
        <link rel="stylesheet" href={META_INFO[appName].fontsLink} />
      )}
    </Helmet>
  )
}
